import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button } from '@components';
import { ProductCategoryPropType } from '@propTypes';

import styles from './styles/index.module.scss';
import { useHeaderContext } from '../../../../../HeaderContext';

const Category = ({
  categories,
  onShowSubcategoryMenu,
  idSelectedCategory,
}) => {
  const { platformBaseUrl } = useHeaderContext();

  const getClassName = id =>
    cn({
      [styles.categoryItem]: true,
      [styles.selectedCategory]: idSelectedCategory === id,
    });
  const onMouseEnter = (id, children) =>
    onShowSubcategoryMenu({ id, children });

  return (
    <ul className={styles.categoryMenu} data-qa="categoriesList">
      {categories.map(({ id, name, url, children }) => (
        <li className={getClassName(id)} key={id}>
          <Button
            tag="a"
            href={`${platformBaseUrl}${url}`}
            color="transparent"
            className={styles.categoryTab}
            onMouseEnter={() => onMouseEnter(id, children)}
          >
            {name}
          </Button>
        </li>
      ))}
    </ul>
  );
};

Category.propTypes = {
  categories: PropTypes.arrayOf(ProductCategoryPropType).isRequired,
  onShowSubcategoryMenu: PropTypes.func.isRequired,
  idSelectedCategory: PropTypes.string.isRequired,
};

export default Category;
